/**
 * @file Redirects away from a missing resource and shows an error.
 */
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { isBackstage } from "@components/Constants";
import { useAppContext } from "@components/AppContext";
import type { AppContext } from "@components/AppContext/types";

const ERROR_MESSAGE = "Requested resource not found";

/**
 * Redirects to the dashboard or investor list and shows a
 * resource-not-found error message.
 */
const ResourceNotFoundRedirect = (): JSX.Element => {
  const navigate = useNavigate();
  const { showErrorMessage } = useAppContext() as AppContext;

  useEffect(() => {
    const path = isBackstage
      ? "/backstage/investors"
      : "/dashboard";

    navigate(path);
    showErrorMessage(ERROR_MESSAGE);
  }, [ navigate, showErrorMessage ]);

  return (<></>);
};

export default ResourceNotFoundRedirect;
